import { hitHapticFeedback } from "@src/utils";
import React from "react";
import styles from "./Button.module.scss";

const Button = ({
  padding6,
  bRadius4,
  outline,
  small,
  xsmall,
  children,
  disabled,
  customClassName,
  onClick,
  ...buttonProps
}) => {
  const buttonActionTimerRef = React.useRef(null);

  React.useEffect(() => {
    return () => clearTimeout(buttonActionTimerRef.current);
  }, []);

  // HANDLE BUTTON CLICKED
  const handleButtonClicked = (e) => {
    e.stopPropagation();
    hitHapticFeedback();
    buttonActionTimerRef.current = setTimeout(() => {
      onClick && onClick();
    }, 400);
  };

  return (
    <button
      onClick={handleButtonClicked}
      className={`${styles.button} ${
        styles[outline ? "button--rippleEffectOutline" : "button--rippleEffect"]
      } ${outline && styles["button--outline"]} ${
        small && styles["button--small"]
      } ${xsmall && styles["button--xsmall"]} ${
        disabled && styles["button--disabled"]
      } ${bRadius4 && styles["button--bRadius4"]} ${
        padding6 && styles["button--padding6"]
      } ${customClassName ? customClassName : ""} `}
      {...buttonProps}
    >
      {children}
    </button>
  );
};

export default Button;
